import React from 'react';
import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';

export const SortTh = ({ label, sortKey, sortConfig, onSort, className = '' }) => {
  const active = sortConfig.key === sortKey;
  const Icon = !active ? ChevronsUpDown : sortConfig.direction === 'asc' ? ArrowUp : ArrowDown;
  return (
    <th className={`text-left p-4 font-semibold text-slate-700 ${className}`}>
      <button onClick={() => onSort(sortKey)} className="inline-flex items-center gap-1 hover:text-slate-900 select-none" data-testid={`sort-${sortKey}`}>
        {label}
        <Icon className={`w-3.5 h-3.5 ${active ? 'text-indigo-600' : 'text-slate-400'}`} />
      </button>
    </th>
  );
};
